var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextFontColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_3474_98836)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.667 12.6671V14.0001H4.33301V12.6671H13.667ZM13.667 3.33302H4.33301V14.0001L4.19727 13.9933C3.56951 13.9296 3.07042 13.4306 3.00684 12.8028L3 12.6671V3.33302C3.00017 2.64272 3.52491 2.07499 4.19727 2.00684L4.33301 2H13.667C14.4031 2.00018 14.9998 2.59689 15 3.33302V12.6671L14.9932 12.8028C14.9251 13.4753 14.3573 14 13.667 14.0001V3.33302ZM9.06445 3.87892L9.19922 3.8926C9.50143 3.95457 9.72831 4.22101 9.73047 4.54104L12.7051 11.0567L12.749 11.1847C12.8186 11.4868 12.669 11.8067 12.376 11.9405C12.0828 12.0744 11.7432 11.9774 11.5605 11.7267L11.4922 11.6104L10.8486 10.2013L10.8262 10.2042H7.2998C7.28402 10.2042 7.26844 10.2004 7.25293 10.1993L6.64062 11.6007L6.5752 11.7188C6.39647 11.9722 6.05784 12.0736 5.7627 11.9444C5.42558 11.7968 5.27239 11.4037 5.41992 11.0665L8.38965 4.27834L8.43555 4.19143C8.55621 3.99903 8.76837 3.87892 9 3.87892H9.06445ZM7.83496 8.87019H10.2412L9.0127 6.17778L7.83496 8.87019Z",
    fill: "#500D76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_3474_98836",
    x: -2,
    y: -2,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3474_98836"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_3474_98836",
    result: "effect2_dropShadow_3474_98836"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3474_98836",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFontColor);
export default __webpack_public_path__ + "static/media/textFontColor.c27fa0fedb0a0f2a23d4ae3b31fe87d8.svg";
export { ForwardRef as ReactComponent };